export default __webpack_public_path__ + "static/media/cozy_house.a16da14b.png";